module.exports = __webpack_public_path__ + "files/c9c1799798ea64d4f37089d8b7dfd827.png";